import React from "react";
import { motion } from "framer-motion";
import ProfileTaskCard from "./ProfileTaskCard";
import { getTaskStatus } from "@/lib/taskUtils";

export default function ProfileTasksList({ tasks, onTaskSelect, optimisticStatuses }) {
  const pendingTasks = tasks.filter((t) => {
    const s = getTaskStatus(t, optimisticStatuses);
    return s === "open" || s === "pending_review";
  });
  const completedTasks = tasks.filter((t) => getTaskStatus(t, optimisticStatuses) === "completed");

  return (
    <section
      dir="rtl"
      style={{ background: "linear-gradient(180deg, #161616 0%, #252525 100%)", padding: "48px 16px 80px" }}
    >
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="font-bold text-white mb-3" style={{ fontSize: "44.8px", lineHeight: "56px" }}>
            המשימות שלי
          </h2>
          <p className="text-base" style={{ color: "#c4c4c4" }}>משימות פתוחות</p>
        </motion.div>

        <div className="space-y-3">
          {pendingTasks.map((task, i) => (
            <ProfileTaskCard
              key={task.id}
              task={task}
              index={i}
              status={getTaskStatus(task, optimisticStatuses)}
              onSelect={onTaskSelect}
            />
          ))}
        </div>

        {completedTasks.length > 0 && (
          <>
            <div className="flex items-center gap-2 my-6">
              <div className="h-px flex-1" style={{ background: "#333" }} />
              <p className="text-xs font-bold uppercase tracking-widest px-2" style={{ color: "rgba(255,255,255,0.35)" }}>
                הושלמו
              </p>
              <div className="h-px flex-1" style={{ background: "#333" }} />
            </div>
            <div className="space-y-3">
              {completedTasks.map((task, i) => (
                <ProfileTaskCard
                  key={task.id}
                  task={task}
                  index={i}
                  status="completed"
                  onSelect={onTaskSelect}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}

export { getTaskStatus };
